export const parseSafeError = (error: any): string => {
  if (!error) return 'Unknown error'

  const code = error?.code
  const status = error?.response?.status ?? error?.status
  const rawMessage: string =
    error?.shortMessage ||
    error?.response?.data?.message ||
    error?.data?.message ||
    error?.message ||
    String(error)

  const lower = String(rawMessage).toLowerCase()

  if (
    code === 4001 ||
    code === 'ACTION_REJECTED' ||
    lower.includes('user rejected') ||
    lower.includes('user denied') ||
    lower.includes('rejected the request')
  ) {
    return 'You rejected the signature request in your wallet.'
  }

  if (status === 401 || status === 403) {
    return 'Not authorized to propose this transaction. Make sure your wallet is an owner of the Safe multisig.'
  }

  if (lower.includes('not an owner') || lower.includes('sender is not an owner')) {
    return 'Your wallet is not an owner of the Safe multisig.'
  }

  if (typeof status === 'number' && status >= 400 && status < 500) {
    return `Safe Transaction Service rejected the request (${status}): ${rawMessage}`
  }

  if (typeof status === 'number' && status >= 500) {
    return `Safe Transaction Service is unavailable (${status}). Please try again in a moment.`
  }

  if (
    lower.includes('network') ||
    lower.includes('fetch failed') ||
    lower.includes('timeout') ||
    code === 'ECONNABORTED' ||
    code === 'ERR_NETWORK'
  ) {
    return 'Network error while talking to Safe Transaction Service. Check your connection and retry.'
  }

  return rawMessage || 'Unexpected error while proposing to Safe multisig.'
}
